import marvelEmitter from '@marvelapp/react-ab-test/lib/emitter';
import qs from 'qs';
import { getCountry, getCountryName } from '/imports/checkout/api/utils';

import env from '/env';
import {
  CLOSE_PRICING_COUNTRY_BROWSER_ONLY_NEW_BROWSER,
  CONTROL_BROSWER_RUN_MOBILE,
  FULLY_NON_TRAIL_COUNTRY,
  FULLY_QUARTERLY_COUNTRY,
  MOBILE_AB_TEST_COUNTRY,
  NEW_PRICE_FOR_BROWSER_AND_RUN_MOBILE,
  NEW_PRICE_ON_BROWSWER_CONTROL_MOBILE,
  NEW_PRICING_FOR_BOTH,
  NON_TRAIL_COUNTRY_ABTEST,
  WINNER_NON_TRAIL_COUNTRY_ON_DESKTOP,
} from '/imports/checkout/api/constants';
import { useCheckoutBillingStore } from '/zustand/CheckoutBillingStore';
import { EU_REBILL_COUNTRIES } from 'lib/helpers';

/**
 * Gets the billing plans for a given [currency].
 *
 * @param {string} currency
 */
export async function getPlans(currency) {
  const queryParams = qs.stringify({ currency });
  let url = `${env.BILLING_ENDPOINT}/v2/plans?${queryParams}`;
  const res = await fetch(url);
  if (res.status !== 200) {
    const text = await res.text();
    throw new Error(text);
  }
  return res.json();
}

//get solidgate signature
export const getSignature = async (intent, token, domain) => {
  const options = {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ ...intent }),
  };
  let url = `${env.BILLING_ENDPOINT}/generate-solid-signature?domain=${domain}`;
  const res = await fetch(url, options);
  if (res.status !== 200) {
    const text = await res.text();
    throw new Error(text);
  }
  return res.json();
};

// get paypal script url
export const getPaypalScriptUrl = async (data, token, domain) => {
  const options = {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ ...data }),
  };
  let url = `${env.BILLING_ENDPOINT}/solid-paypal-intent?domain=${domain}`;
  const res = await fetch(url, options);
  if (res.status !== 200) {
    const text = await res.text();
    console.log('text :>> ', text);
    return {};
  }
  return res.json();
};

export const updateUserDomain = async (domain, token) => {
  const queryParams = qs.stringify({ domain });
  let url = `${env.BILLING_ENDPOINT}/update-user-domain?${queryParams}`;
  const options = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  const res = await fetch(url, options);
  if (res.status !== 200) {
    const text = await res.text();
    throw new Error(text);
  }
  return true;
};

export const getTrustPilotRules = async () => {
  let url = `${env.BILLING_ENDPOINT}/load-balancing-trust-pilots`;
  const options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  };
  const res = await fetch(url, options);
  if (res.status !== 200) {
    const text = await res.text();
    throw new Error(text);
  }
  return res.json();
};

export const getTrustPilotRulesException = async () => {
  let url = `${env.BILLING_ENDPOINT}/trust-pilot-balancer-exceptions`;
  const options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  };
  const res = await fetch(url, options);
  if (res.status !== 200) {
    const text = await res.text();
    throw new Error(text);
  }
  return res.json();
};

export const getCheckoutSession = async ({ returnUrl, coupen, priceId, plan, ...rest }) => {
  const country = getCountryName();
  const options = {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      coupen: coupen,
      priceId: priceId,
      return_url: returnUrl,
      plan: plan,
      country,
      builderUserId: rest?.builderUserId,
    }),
  };
  let url = `${env.BILLING_ENDPOINT}/create-stripe-checkout-session`;
  const res = await fetch(url, options);
  if (res.status !== 202) {
    const text = await res.text();
    throw new Error(text);
  }
  return res.json();
};

export const changeUserRole = async (domain, billingVersion, token) => {
  const options = {
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  };
  let url = `${env.BILLING_ENDPOINT}/change-user-role?domain=${domain}&billingVersion=${billingVersion}`;
  const res = await fetch(url, options);
  if (res.status !== 200) {
    const text = await res.text();
    throw new Error(text);
  }
  return res.json();
};

export const getMollieId = async (domain) => {
  const options = {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  };
  let url = `${env.BILLING_ENDPOINT}/mollie-profile-id?domain=${domain}`;
  const res = await fetch(url, options);
  if (res.status !== 200) {
    const text = await res.text();
    throw new Error(text);
  }
  return res.json();
};

export const reviewClientsTest = async (data) => {
  const options = {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  };
  let url = `${env.BASE_API}/agent/resume-clients`;
  const res = await fetch(url, options);
  if (res.status !== 200) {
    const text = await res.text();
    throw new Error(text);
  }
  return res.json();
};

export const rwCreateLeadStore = () => {
  window.localStorage.setItem('user:rw-lead-created', true);
};

export const isRwLeadAlreadyCreated = () => {
  return window.localStorage.getItem('user:rw-lead-created') === 'true';
};

export const reviewClients = async (data, token) => {
  const options = {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  };
  if (token) options.headers.Authorization = `Bearer ${token}`;
  let url = `${env.BASE_API}/agent/resume-clients`;
  const res = await fetch(url, options);
  if (res.status !== 200) {
    const text = await res.text();
    throw new Error(text);
  }
  return res.json();
};

export const writingPaymentSuccess = async (data, token) => {
  const options = {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  };
  let url = `${env.BILLING_ENDPOINT}/resume-writing-payment-success`;
  const res = await fetch(url, options);
  if (res.status !== 200) {
    const text = await res.text();
    throw new Error(text);
  }
  return res.json();
};

export const getLBRules = async (domain, countryCode) => {
  let url = `${env.BILLING_ENDPOINT}/load-balancer-rules?domain=${domain}&countryCode=${countryCode}`;
  const options = {
    method: 'GET',
  };
  const res = await fetch(url, options);
  if (res.status !== 200) {
    const text = await res.text();
    throw new Error(text);
  }
  return res.json();
};

export const resumeWritingCharge = async (data, token, isSecondTime, isNew) => {
  const options = {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  };
  let url = `${env.BILLING_ENDPOINT}/charge-customer-builder`;
  const res = await fetch(url, options);
  if (!res.ok) {
    if (!isSecondTime) {
      if (data?.billingVersion === 5 && res.status === 400) {
        const result = await res.text();
        const data = { result, inSuffientFund: true };
        if (isNew) {
          data.error = true;
        }
        return data;
      }
      if (res.status === 402) {
        const result = await res.text();
        const data = { result, inSuffientFund: true };
        if (isNew) {
          data.error = true;
        }
        return data;
      }
    }
    const result = await res.text();
    return { result, error: true };
  }
  const result = await res.json();
  return { result };
};

export const getStripeCheckoutProduct = async () => {
  let url = `${env.BILLING_ENDPOINT}/get-checkout-stripe-plan`;
  const res = await fetch(url);
  return res.json();
};

export const isNewPricingVariantExperiment3 = (width) => {
  const country = getCountry();
  if (width <= 450 && CLOSE_PRICING_COUNTRY_BROWSER_ONLY_NEW_BROWSER.includes(country)) return true;
  if (NEW_PRICING_FOR_BOTH.includes(country)) return true;
  if (
    width >= 450 &&
    (NEW_PRICE_FOR_BROWSER_AND_RUN_MOBILE.includes(country) || NEW_PRICE_ON_BROWSWER_CONTROL_MOBILE.includes(country))
  )
    return true;
  if (width <= 450 && NEW_PRICE_ON_BROWSWER_CONTROL_MOBILE.includes(country)) return false;
  if (width >= 450 && CONTROL_BROSWER_RUN_MOBILE.includes(country)) return false;
  return marvelEmitter.getActiveVariant('exp_initial_pricing') === 'new_pricing';
};

export const disabledExpSolidCtaLocale = [
  'en',
  'es',
  'tr',
  'pt-br',
  'ro',
  'ru',
  'cs',
  'lv',
  'ar',
  'lt',
  'fr',
  'ms',
  'vi',
  'de',
  'hu',
  'zh-cn',
];

export const allowedFreeRWLocale = [''];

export const subscriptionPlan = async (token, billingVersion) => {
  const options = {
    method: 'PATCH',
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ billingVersion }),
  };
  let url = `${env.BILLING_ENDPOINT}/subscription-plan`;
  const res = await fetch(url, options);
  if (res.status !== 200) {
    const text = await res.text();
    throw new Error(text);
  }
  return res.json();
};

export const isWithNonTrailEnabled = (country, isMobile, host, billingVersion = '', provider) => {
  if (!country) return false;
  if (marvelEmitter.getActiveVariant('exp_peru_plans') === 'control') return false;
  if (marvelEmitter.getActiveVariant('exp_indonesia_plans') === 'control') return false;
  if (marvelEmitter.getActiveVariant('exp_andorra_finland_new_plans') === 'control') return false;
  if (marvelEmitter.getActiveVariant('exp_australia_plans') === 'control') return false;
  if (marvelEmitter.getActiveVariant('exp_non_trail_offer') === 'control') return false;
  if (host === 'resumetiger' && (billingVersion == 9 || provider === 'razorpay')) return false;
  if (!isMobile && WINNER_NON_TRAIL_COUNTRY_ON_DESKTOP.includes(country)) return true;
  if (FULLY_NON_TRAIL_COUNTRY.includes(country)) return true;
  if (!NON_TRAIL_COUNTRY_ABTEST.includes(country) && !(isMobile && MOBILE_AB_TEST_COUNTRY.includes(country)))
    return false;
  return true;
};

export const getAbtestWisePlansAmount = (host, isMobile, currentPlan, billingVersion = '', provider) => {
  const country = getCountry();
  const withNonTrail = isWithNonTrailEnabled(country, isMobile, host, billingVersion, provider);
  const andorraFinlandPlans = marvelEmitter.getActiveVariant('exp_andorra_finland_new_plans');
  const indonesiaPlans = marvelEmitter.getActiveVariant('exp_indonesia_plans');

  if (
    (EU_REBILL_COUNTRIES.includes(country) && andorraFinlandPlans !== '19m9w') ||
    andorraFinlandPlans == 'control' ||
    indonesiaPlans == 'control'
  ) {
    return {
      trialAmount: currentPlan?.trialAmount,
      amount: currentPlan?.amount,
    };
  } else if (withNonTrail) {
    return {
      trialAmount: currentPlan?.amount,
      amount: currentPlan?.amount,
    };
  } else {
    return {
      trialAmount: currentPlan?.trialAmount,
      amount: currentPlan?.amount,
    };
  }
};

export const billingCycleWiseText = (billingCycle) => {
  switch (billingCycle) {
    case 7:
      return {
        text: 'payment_week',
        recurringText: 'payment_week',
      };
    case 30:
      return {
        text: 'payment_month',
        recurringText: 'checkout_monthly',
      };
    case 90:
      return {
        text: 'payment_quarter',
        recurringText: 'checkout_quarterly',
      };
    case 365:
      return {
        text: 'year',
        recurringText: 'yearly',
      };
    default:
      return {
        text: 'payment_week',
        recurringText: 'payment_week',
      };
  }
};

export const getPaymentPeriodText = (currentPlan, staticPeriod, isOldCheckout) => {
  const country = getCountry();
  const ukarineGreccePlans = marvelEmitter.getActiveVariant('exp_ukraine_greece_plans');
  const indonesiaPlans = marvelEmitter.getActiveVariant('exp_indonesia_plans');
  const SouthAfricaPlans = marvelEmitter.getActiveVariant('exp_southafrica_plans') == 'var_1';
  const australiaPlans = marvelEmitter.getActiveVariant('exp_australia_plans');
  const peruPlans = marvelEmitter.getActiveVariant('exp_peru_plans');
  const ParaguayPlans = marvelEmitter.getActiveVariant('exp_paraguay_plans');
  const pakistanPlans = marvelEmitter.getActiveVariant('exp_pakistan_plans');
  const philippinesPlans = marvelEmitter.getActiveVariant('exp_philippines_plans');

  const fullyQuerterlyCountry = FULLY_QUARTERLY_COUNTRY.includes(country);

  const withQuartlyPlans =
    fullyQuerterlyCountry ||
    SouthAfricaPlans ||
    peruPlans === 'var_2' ||
    ukarineGreccePlans == 'var_1' ||
    indonesiaPlans == 'var_2' ||
    ParaguayPlans == 'var_2' ||
    pakistanPlans == 'var_2' ||
    philippinesPlans == '16q5w';

  if (staticPeriod) {
    if (withQuartlyPlans) {
      return {
        text: isOldCheckout ? 'payment_quarter' : 'payment_month',
        recurringText: isOldCheckout ? 'checkout_quarterly' : 'checkout_monthly',
      };
    }
    if (australiaPlans == 'var_2') {
      return {
        text: isOldCheckout ? 'year' : 'payment_month',
        recurringText: isOldCheckout ? 'yearly' : 'checkout_monthly',
      };
    }
  }
  return billingCycleWiseText(currentPlan?.billingCycle);
};

export const getPaymentTrialDays = (host, isMobile, currentPlan, isRroute = false, billingVersion) => {
  const country = getCountry();
  const withNonTrail = isWithNonTrailEnabled(country, isMobile, host, billingVersion) || isRroute;
  const andorraFinlandPlans = marvelEmitter.getActiveVariant('exp_andorra_finland_new_plans');
  const SouthAfricaPlans = marvelEmitter.getActiveVariant('exp_southafrica_plans') == 'var_1';
  const ukarineGreccePlans = marvelEmitter.getActiveVariant('exp_ukraine_greece_plans');
  const indonesiaPlans = marvelEmitter.getActiveVariant('exp_indonesia_plans');
  const peruPlans = marvelEmitter.getActiveVariant('exp_peru_plans');
  const ParaguayPlans = marvelEmitter.getActiveVariant('exp_paraguay_plans');
  const pakistanPlans = marvelEmitter.getActiveVariant('exp_pakistan_plans');
  const philippinesPlans = marvelEmitter.getActiveVariant('exp_philippines_plans');
  const isResumeTiger = host === 'resumetiger' && billingVersion === 9;
  const fullyQuerterlyCountry = !isResumeTiger && FULLY_QUARTERLY_COUNTRY.includes(country);

  const withNonQuartlyPlans =
    fullyQuerterlyCountry ||
    SouthAfricaPlans ||
    peruPlans === 'var_2' ||
    ukarineGreccePlans == 'var_1' ||
    indonesiaPlans == 'var_2' ||
    ParaguayPlans == 'var_2' ||
    country === 'TR' ||
    pakistanPlans == 'var_2' ||
    philippinesPlans == '16q5w';

  if (withNonQuartlyPlans) {
    return {
      trialDays: currentPlan?.billingCycle,
      totalDays: currentPlan?.billingCycle,
    };
  } else if (indonesiaPlans == 'control' || andorraFinlandPlans == 'control') {
    return {
      trialDays: currentPlan?.trialDays,
      totalDays: currentPlan?.billingCycle,
    };
  } else if (withNonTrail) {
    return {
      trialDays: currentPlan?.billingCycle,
      totalDays: currentPlan?.billingCycle,
    };
  } else {
    return {
      trialDays: currentPlan?.trialDays,
      trialAmount: currentPlan?.trialDays,
      amount: currentPlan?.billingCycle,
    };
  }
};

export const getCheckoutText = (country, isMobile, host, isAutoApply, activePlanItem, isR2route, billingVersion) => {
  const WithNonTrial = isWithNonTrailEnabled(country, isMobile, host, billingVersion);
  const SouthAfricaPlans = marvelEmitter.getActiveVariant('exp_southafrica_plans') == 'var_1';
  const peruPlans = marvelEmitter.getActiveVariant('exp_peru_plans');

  const ukarineGreccePlans = marvelEmitter.getActiveVariant('exp_ukraine_greece_plans');
  const indonesiaPlans = marvelEmitter.getActiveVariant('exp_indonesia_plans');
  const ParaguayPlans = marvelEmitter.getActiveVariant('exp_paraguay_plans');
  const pakistanPlans = marvelEmitter.getActiveVariant('exp_pakistan_plans');
  const philippinesPlans = marvelEmitter.getActiveVariant('exp_philippines_plans');
  const isResumeTiger = host === 'resumetiger' && billingVersion === 9;

  const fullyQuerterlyCountry = !isResumeTiger && FULLY_QUARTERLY_COUNTRY.includes(country);

  const withNonQuartlyPlans =
    fullyQuerterlyCountry ||
    SouthAfricaPlans ||
    peruPlans === 'var_2' ||
    ukarineGreccePlans == 'var_1' ||
    indonesiaPlans == 'var_2' ||
    ParaguayPlans == 'var_2' ||
    pakistanPlans == 'var_2' ||
    philippinesPlans == '16q5w' ||
    isR2route;

  const planName = activePlanItem?.name || activePlanItem;

  if (withNonQuartlyPlans && planName == 'Quarterly Plan') {
    return 'non_trail_quarterly_text';
  }

  if (WithNonTrial) {
    if (planName === '14-DAY LIMITED ACCESS' || planName === 'Weekly Plan') {
      return 'non_trail_weekly_text';
    } else if (planName === 'Yearly Plan') {
      return 'payment.pricing_yearly_non_trail';
    } else {
      return 'non_trail_monthly_text';
    }
  }

  if (isAutoApply) {
    if (planName === '14-DAY LIMITED ACCESS') {
      return 'offer_cta_1';
    } else {
      return 'offer_cta_2';
    }
  }

  return 'new_checkout_access_txt';
};

export const getMollieTransactionStatus = async (transactionId, token) => {
  const fetchOptions = {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };
  const response = await fetch(`${env.BILLING_ENDPOINT}/transaction/${transactionId}`, fetchOptions);
  if (response.status !== 200) {
    const text = await response.text();
    throw new Error(text);
  }
  return response.json();
};

export const RenderSpainshCTAText = (SpanishCTAVar) => {
  switch (SpanishCTAVar) {
    case 'var_a':
      return 'payment.spanish_cta_text_varA';
    case 'var_b':
      return 'payment.spanish_cta_text_varB';
    case 'var_c':
      return 'payment.spanish_cta_text_varC';
    case 'var_d':
      return 'payment.spanish_cta_text_varD';
    default:
      return 'payment.solid_cta_var2';
  }
};

export const RenderSpainshCTATextStrip = (SpanishCTAVar) => {
  switch (SpanishCTAVar) {
    case 'var_a':
      return 'payment.spanish_cta_text_varA';
    case 'var_b':
      return 'payment.spanish_cta_text_varB';
    case 'var_c':
      return 'payment.spanish_cta_text_varC';
    case 'var_d':
      return 'payment.spanish_cta_text_varD';
    default:
      return 'payment.get_your_resume';
  }
};
